// extracted by mini-css-extract-plugin
module.exports = {"container":"_2HxpGFpFxOVSiyN2jFEXTS","item":"_2inzM-Eh4iXPjvyY9TzoSl","icon":"_2pk9vbG2ohPP5hmGpBU_Nc","dot":"UWKNPrHlEK5Bzwln2CaNn"};